import { gql, TypedDocumentNode } from '@apollo/client'

export const ARCHIVE_ITEM: TypedDocumentNode<{ result: { id: string } }, { itemId: string }> = gql`
  mutation archiveItem($itemId: uuid!) {
    result: update_item_by_pk(pk_columns: { id: $itemId }, _set: { is_archived: true }) {
      id
    }
  }
`
